// src/components/utils/utils/resolveServicePhoto.js
export function resolveServicePhoto(baseURL, photo) {
  if (!photo) return "";

  // Normalize baseURL once
  const base = baseURL?.replace(/\/+$/, "") || "";

  // If it's already an absolute URL, return as-is
  if (typeof photo === "string" && /^https?:\/\//i.test(photo)) return photo;

  // If backend sent HTML-escaped JSON, unescape first
  let raw = photo;
  if (typeof raw === "string" && raw.includes("&quot;")) {
    raw = raw.replaceAll("&quot;", '"').replaceAll("&amp;", "&");
  }

  // Try to parse JSON blob { filename, extension } or { filepath, filename, extension, token }
  try {
    const obj = typeof raw === "string" ? JSON.parse(raw) : raw;

    const filename = [obj?.filename, obj?.extension].filter(Boolean).join(".");
    if (!filename) throw new Error("No filename in JSON");

    // IMPORTANT: do not change case — use the exact filename from the API/db
    const encodedFile = encodeURIComponent(filename);

    // You confirmed the working public path is /media/uploads/service
    const url = `${base}/media/uploads/service/${encodedFile}`;

    // If a token is required by your API, keep it
    return obj?.token ? `${url}?token=${encodeURIComponent(obj.token)}` : url;
  } catch {
    // Not JSON. Treat as a plain filename or relative path
    const plain = String(photo).trim();

    // If it already looks like a /media/... path, encode each segment safely
    if (plain.startsWith("/media/")) {
      const encoded = plain
        .split("/")
        .map(seg => (seg ? encodeURIComponent(seg) : seg))
        .join("/");
      return `${base}${encoded}`;
    }

    // Otherwise assume it's just the filename (preserve case)
    const encodedFile = plain
      .split("/")
      .map(seg => (seg ? encodeURIComponent(seg) : seg))
      .join("/");

    return `${base}/media/uploads/service/${encodedFile}`;
  }
}
